import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationFacade } from '@core/facades/notification.facade';
import { PortfolioListDatum } from '@core/models/admin/portfolio';
import { BreadCrumbService } from '@core/services/bread-crumb.service';
import { PortfolioService } from '@core/services/portfolio.service';
import { TableSkeletonLoaderComponent } from '@shared/ui/table-skeleton-loader/table-skeleton-loader.component';
import { IFILTER } from 'app/app.constants';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-full-portfolio',
  standalone: true,
  imports: [CommonModule, TableSkeletonLoaderComponent],
  templateUrl: './full-portfolio.component.html',
  styleUrl: './full-portfolio.component.scss',
})
export class FullPortfolioComponent implements OnInit ,OnDestroy{
  porfolioList: PortfolioListDatum[] = [];
  accountId!: string;
  subs: Subscription[] = [];
  totalCount: number = 0;

  isFetchingPortfolioList$!: Observable<boolean>;

  private activatedRoute = inject(ActivatedRoute);
  private breadCrumbService = inject(BreadCrumbService);
  private portfolioService = inject(PortfolioService);
  private change = inject(ChangeDetectorRef);
  private toast = inject(NotificationFacade);

  filterStructure: IFILTER[] = [
    {
      filterKey: 'ccy',
      label: 'CCY',
      type: 'dropdown',
      dropdown: [
        { key: 'USD', value: 'USD' },
        { key: 'NGN', value: 'NGN' },
      ],
    },
  ];

  ngOnInit() {
    this.accountId = this.activatedRoute.snapshot.parent?.parent?.params['accountId'];

    this.breadCrumbService.setPageBreadCrumb(this.activatedRoute);
    if (this.accountId) {
      this.portfolioFiltersEventListener();
    }
  }

  portfolioFiltersEventListener() {
    this.activatedRoute.queryParams.subscribe((params) => {
      let query = '';

      if (params[this.filterStructure[0].filterKey]) {
        query = `ccy=${params['ccy']}&`;
      }
      if (params['search']) {
        query += `search_text=${params['search']}`;
      }
      if (query) {
        const sub = this.portfolioService
          .filterPortfolioList(query, this.accountId)
          .subscribe({
            next: (res) => {
              this.porfolioList = res.data.data;
              this.totalCount = 10; // 10 to remove pagination

              this.change.detectChanges();
            },
            error: (err) => {},
          });
        this.subs.push(sub);
      } else {
        this.getPortfolioList();
      }
    });
  }

  getPortfolioList() {
    const sub = this.portfolioService
      .getPortfolioList(this.accountId)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.porfolioList = res.data.data;

          this.change.detectChanges();
        },
        error: () => {
          this.toast.error('Failed to fetch portfolio data');
          this.change.detectChanges();
        },
      });

    this.subs.push(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
